import { Yield } from '../../abacus/interfaces/yield.interface'

export const countryYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  }
]
